<template>
  <div>
    <div class="qr">
      <div class="title">{{$t('shareQr')}}</div>
      <img :src="qrImage" alt="">
    </div>
    <div class="url-wrap">
      <div class="title">{{$t('shareLink')}}：</div>
        <div class="url" v-if="share_type == 'system'">
          {{`${apiBaseUrl}web/jump?name=${invite}`}}  
        </div>
		<div class="url" v-else>
          {{`${apiBaseUrl}web/jump?code=${invite}`}}  
        </div>
		<span class="sharecode" @click="show">custom</span>
    </div>
    <el-dialog :visible.sync="shareDia" width="600px" title="Set custom sharing code" :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
    	<div>
    		<div class="adress-form">
    			<div class="form-section">
    			  <input
    			    type="text"
    			    placeholder="Please enter the sharing code"
    			    class="input-text input-control"
    			    v-model="share_code"
    			  >
    			  <label for class="input-label">My Code</label>
    			</div>
    		</div>	
    		<div class="form-foot">
    			<div class="foot-btn cancel" @click="shareDia = false">Close</div>
    			<div class="foot-btn save" @click="setShare">{{ $t('setting') }}</div>
    		</div>
    	</div>
    </el-dialog>
  </div>
</template>

<script>
import {apiBaseUrl} from '@/config/env.js'
export default {
  data() {
		return {
			qrImage: '',
			invite: '',
			apiBaseUrl: apiBaseUrl,
			shareDia: false,
			share_code: '',
			share_type: 'system'
		}
  },
  methods: {
    init() {

      this.$api.shareCode({}).then(res => {
        if(res.status) {
          this.invite = res.data
		  this.share_type = res.type
        }
      })


      let data =  {
        client: 1,
        page: 1,
        params: {store: localStorage.getItem('businessId') - 0},
        token: this.$storage.get('userToken'),
        type: 2,
        url: apiBaseUrl + "wap/pages/share/jump"
      }
      this.$api.share(data).then(res => {
        if(res.status) {
          this.qrImage = res.data
        }
      })
    },
	show() {
		this.shareDia = true;
		this.share_code = this.invite
	},
	setShare() {
		const _this = this
		this.$api.shareCusCode({share_code: this.share_code}).then(res => {
			if (res.status) {
				this.shareDia = false
				this.init()
				_this.$msg(res.msg);
			}else{
				_this.$msg(res.msg, "warning");
			}
		})
	},
  },
  created() {
    this.init()
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/mixin.scss";
@import "@/assets/css/variable.scss";
.qr {
  display: flex;
  .title {
    font-size: 12px;
    margin-top: 10px;
  }
}
img {
  width: 200px;
  height: 200px;
}
.url{
    font-size: 12px;
    padding: 18px 24px;
    background-color: #fafafa;
    border: 1px solid #eaeefb;
    border-radius: 4px;
}
.sharecode {
		margin-left: 20px;
		color: blue;
		cursor: pointer;
	}
.url-wrap {
  display: flex;
  align-items: center;
  margin-top: 20px;
}
.adress-form {
  width: 580px;
  margin: 0 auto;
  padding: 30px 10px;
  display: flex;
  justify-content: space-between;
  flex-flow: row wrap;
  align-content: flex-start;
	.form-section {
    position: relative;
    margin-bottom: 15px; 
		.input-control {
		  margin: 0;
		  font-size: 14px;
		  line-height: 1.5;
		  outline: none;
		  padding: 10px 16px;
		  border: 1px solid #e0e0e0;
		  transition: border-color 0.25s linear;
		  &.input-text {
		    height: 18px;
		    line-height: 18px;
		  }
		  &:focus {
		    border-color: $theme-color;
		  }
		  &:placeholder-shown::placeholder {
		    color: transparent;
		  }
		  &:not(:placeholder-shown)::placeholder,
		  &:focus::placeholder {
		    color: #b0b0b0;
		  }
		  /* 线框样式label定位 */
		  &:not(:placeholder-shown) ~ .input-label,
		  &:focus ~ .input-label {
		    color: $theme-color;
		    transform: scale(0.75) translate(-2px, -24px);
		  }
		}
		.input-text {
		  width: 540px;
		}
		.input-textarea {
		  width: 100%;
		  box-sizing: border-box;
		  resize: none;
		}
		.input-label {
		  position: absolute;
		  font-size: 16px;
		  line-height: 1.5;
		  left: 16px;
		  top: 8px;
		  color: #b0b0b0;
		  background: #fff;
		  padding: 0 2px;
		  transform-origin: 0 0;
		  pointer-events: none;
		  transition: all 0.25s linear;
		  display: none\0;
		}
	}	
}	
.form-foot {
	display: flex;
	justify-content: center;
	padding: 20px 0;
	background: #f5f5f5;
	.foot-btn {
		width: 160px;
		text-align: center;
		height: 40px;
		line-height: 40px;
		color: #fff;
		cursor: pointer;
		&.save {
			background: $theme-color;
			margin-right: 20px;
			margin-left: 20px;
		}
		&.cancel {
			background: #b0b0b0;
			transition: all 0.2s;
			&:hover {
				background: #757575;
			}
		}
	}
}
</style>